<template>
    <div class="searchPrice" >
        <div class="price-item" v-for="(item,index) in washServicePriceList" :key="index" @click="onPrice(item)" v-if="item.servicePrice">
            {{ item.service.serviceName }} ({{item.servicePrice}}元)
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    props:{
        productId:{
            type: String,
            default: ''
        }
    },
    data(){
        return{
            washServicePriceList: [],
        }
    },
    methods:{
        getWashServicePriceList(){
            if(this.productId == null){
                return
            }
            get(`/wash/serviceprice/findAllByProductId?productId=${this.productId}`).then((res)=>{
                if(res.success){
                    this.washServicePriceList = res.list
                }
            })
        },

        onPrice(priceItem){
            this.$emit("onPrice", priceItem)
        }
    }
}
</script>

<style scoped lang="scss">
.searchPrice{
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .price-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }

}
</style>